import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { CircularProgress, Typography, Button, Box } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import classNames from 'classnames';
import { INITIAL_SORT_STATE } from './ListagemPlanosTableConstants';
import { useAuth } from '../../../../auth/authProvider';
import partnershipRequest from '../../../../services/network/partnershipRequest';
import ListagemPlanosParametrosTable from './ListagemPlanosParametros/ListagemPlanosParametrosTable';
import CadastroPlanos from '../CadastroPlanos/CadastroPlanos';

const ListagemPlanos = () => {
  const { token } = useAuth();
  const [showCadastro, setShowCadastro] = useState(false);
  const [editingPlanId, setEditingPlanId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sorts, setSorts] = useState(INITIAL_SORT_STATE);

  const getSortField = () => {
    if (sorts.name) {
      return 'name';
    }
    if (sorts.createdAt) {
      return 'createdAt';
    }
    return 'name';
  };

  const getSortValue = () => {
    if (sorts.name) {
      return sorts.name.toLowerCase();
    }
    if (sorts.createdAt) {
      return sorts.createdAt.toLowerCase();
    }
    return 'asc';
  };

  const { isFetching: isLoading, refetch } = useQuery(
    ['fetch-comission-plans', currentPage, rowsPerPage, sorts],
    () => {
      const offset = (currentPage - 1) * rowsPerPage + 1;
      const params = {
        offset,
        limit: rowsPerPage,
        sortField: getSortField(),
        sortValue: getSortValue(),
        relations: JSON.stringify([
          'comissionPayment',
          'comissionScales',
          'comissionBonus',
          'comissionPenalties',
          'tarifaDistribuidoras',
        ]),
      };
      return partnershipRequest.get('comissions/comission-plans', { token, params });
    },
    {
      onSuccess: data => {
        if (Array.isArray(data)) {
          setTableData(data);
          setTotal(data.length);
        } else {
          setTableData([...(data.data || data.content || [])]);
          setTotal(data.total || data.count || 0);
        }
      },
    },
  );

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleAddNewPlan = () => {
    setEditingPlanId(null);
    setShowCadastro(true);
  };

  const handleEditPlan = planId => {
    setEditingPlanId(planId);
    setShowCadastro(true);
  };

  const handleBackToList = () => {
    setShowCadastro(false);
    setEditingPlanId(null);
    refetch();
  };

  if (showCadastro) {
    return <CadastroPlanos onCancel={handleBackToList} onSuccess={handleBackToList} planId={editingPlanId} />;
  }

  const renderContent = () => {
    if (isLoading) {
      return (
        <div
          className={classNames.progressWrapper}
          style={{ height: '60%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <CircularProgress />
        </div>
      );
    }

    return (
      <>
        <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={2}>
          <Typography variant="h6">Planos de Comissionamento</Typography>
          <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAddNewPlan}>
            Adicionar Novo Plano
          </Button>
        </Box>
        {tableData.length === 0 ? (
          <Typography>Ops. Não encontramos nada.</Typography>
        ) : (
          <ListagemPlanosParametrosTable
            data={tableData}
            setSorts={setSorts}
            sorts={sorts}
            total={total}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            onEdit={handleEditPlan}
          />
        )}
      </>
    );
  };

  return <>{renderContent()}</>;
};

export { ListagemPlanos };
